<template>
    <div class="modal-alert-error">
        <div class="modal-alert">
            <div class="modal-alert-error-mark">
                <span class="modal-alert-error-left"></span>
                <span class="modal-alert-error-right"></span>
            </div>
            <div class="modal-success-fix"></div>
        </div>
        <div class="modal-alert-text"><slot></slot></div>
    </div>
</template>

<script>
export default {};
</script>
